import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IGetQueryParams,
  ICategoryGlobalListingResponseAction,
  ICreateCategoryGlobalPayload,
} from "../../interfaces/Index";
import {
  createCategoryGlobalApiCall,
  getCategoriesGlobalApiCall,
  getCoreCategoriesGlobalApiCall,
  untagCategoryZoneApiCall,
  updateCategoryGlobalApiCall,
} from "../sources/CategoryGlobalSource";

export const createCategoryGlobalInit = () => ({
  type: actionTypes.CREATE_CATEGORY_GLOBAL_INIT,
});

export const createCategoryGlobalSuccess = () => ({
  type: actionTypes.CREATE_CATEGORY_GLOBAL_SUCCESS,
});

export const createCategoryGlobalFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_CATEGORY_GLOBAL_FAIL,
  error,
});

export const fetchCategoriesGlobalInit = () => ({
  type: actionTypes.GET_CATEGORIES_GLOBAL_LIST_INIT,
});

export const fetchCategoriesGlobalSuccess = (
  payload: ICategoryGlobalListingResponseAction
) => ({
  type: actionTypes.GET_CATEGORIES_GLOBAL_LIST_SUCCESS,
  payload,
});

export const fetchCategoriesGlobalFail = (error: string | object | null) => ({
  type: actionTypes.GET_CATEGORIES_GLOBAL_LIST_FAIL,
  error,
});

export const categoryGlobalUpdateInit = () => ({
  type: actionTypes.UPDATE_CATEGORY_GLOBAL_INIT,
});

export const categoryGlobalUpdateSuccess = () => ({
  type: actionTypes.UPDATE_CATEGORY_GLOBAL_SUCCESS,
});

export const categoryGlobalUpdateFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_CATEGORY_GLOBAL_FAIL,
  error,
});

export const getCoreCategoriesGlobalInit = () => ({
  type: actionTypes.GET_CORE_CATEGORIES_GLOBAL_INIT,
});

export const getCoreCategoriesGlobalSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_CORE_CATEGORIES_GLOBAL_SUCCESS,
  payload,
});

export const getCoreCategoriesGlobalFail = (error: string | object | null) => ({
  type: actionTypes.GET_CORE_CATEGORIES_GLOBAL_FAIL,
  error,
});

// async actions

export const createCategoryGlobal = (payload: ICreateCategoryGlobalPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(createCategoryGlobalInit());
  return createCategoryGlobalApiCall(payload)
    .then(() => dispatch(createCategoryGlobalSuccess()))
    .catch((e: object | null | string) =>
      dispatch(createCategoryGlobalFail(e))
    );
};

export const getCategoriesGlobalList = (
  isProductDetailPage: boolean = false,
  queryParams?: IGetQueryParams
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(fetchCategoriesGlobalInit());
  return getCategoriesGlobalApiCall(queryParams, isProductDetailPage)
    .then((categoriesGlobal: ICategoryGlobalListingResponseAction) =>
      dispatch(fetchCategoriesGlobalSuccess(categoriesGlobal))
    )
    .catch((e: object | null | string) =>
      dispatch(fetchCategoriesGlobalFail(e))
    );
};

export const updateCategoryGlobal = (
  id: string,
  payload: ICreateCategoryGlobalPayload
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(categoryGlobalUpdateInit());
  return updateCategoryGlobalApiCall(id, payload)
    .then(() => dispatch(categoryGlobalUpdateSuccess()))
    .catch((e: object | null | string) =>
      dispatch(categoryGlobalUpdateFail(e))
    );
};

export const getCoreCategoriesGlobal = () => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(getCoreCategoriesGlobalInit());
  return getCoreCategoriesGlobalApiCall()
    .then((data: any) => dispatch(getCoreCategoriesGlobalSuccess(data)))
    .catch((e: object | null | string) =>
      dispatch(getCoreCategoriesGlobalFail(e))
    );
};
